"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupContext = void 0;
var compat_1 = require("preact/compat");
exports.SignupContext = (0, compat_1.createContext)({
    formStep: 0,
    setFormStep: function () { },
    modalOpen: false,
    setModalOpen: function () { },
    miniPopupOpen: false,
    setMiniPopupOpen: function () { },
});
